// extracted by mini-css-extract-plugin
export default {"advert":"_2T9LXz7"};